define('app/sdc/browser/compatibility/modal/close/sdc-browser-compatibility-modal-close',[],function () {
	return {
		restrict: "A",
		require: {
			"close": "^sdc-browser-compatibility-modal.close"
		},
		controller: {

		}
	}
});
